"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityFilters = exports.EntityFiltersDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var client_1 = require("@apollo/client");
var use_lang_1 = require("../../hooks/use-lang");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var use_theme_1 = require("../../hooks/use-theme");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var current_user_can_1 = require("../../utils/current-user-can");
var use_app_options_1 = require("../../hooks/use-app-options");
var entity_filters_query_1 = require("../../utils/entity-filters-query");
var lodash_1 = require("lodash");
var input_select_1 = require("../forms/input-select");
var filters_1 = require("../elements/filters");
var loading_layout_1 = require("../elements/loading-layout");
var entity_filter_label_1 = require("./entity-filter-label");
exports.EntityFiltersDefaultProps = {
  onChange: function (fields) {},
  fieldNames: [],
  values: {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: visible;\n    z-index: 100;\n  "], ["\n    overflow: visible;\n    z-index: 100;\n  "])))
});
var FiltersStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-weight: 400;\n    font-size: ", ";\n  "], ["\n    text-transform: uppercase;\n    font-weight: 400;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14))
});
var LoadingLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(10))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  InputSelect: input_select_1.InputSelect,
  Filters: (0, styled_components_1.default)(filters_1.Filters)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), FiltersStyles),
  Label: styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles)
};
var EntityFilters = function (props) {
  var className = props.className,
    onChange = props.onChange,
    _a = props.values,
    values = _a === void 0 ? {} : _a,
    entityTypeName = props.entityTypeName,
    fieldNames = props.fieldNames;
  if (!entityTypeName) {
    throw new Error("Entity Filters cannot be created. Missing entity name.");
  }
  var theme = (0, use_theme_1.useTheme)();
  var entities = (0, use_entities_1.useEntities)();
  var icons = (0, use_icons_1.useIcons)();
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var list = definition.list,
    filters = definition.filters;
  var options = (0, use_app_options_1.useAppOptions)();
  var client = (0, client_1.useApolloClient)();
  var defaultData = {};
  var query = (0, entity_filters_query_1.entityFiltersQuery)({
    definition: definition,
    entities: entities
  });
  var _b = (0, client_1.useQuery)(query, {
      notifyOnNetworkStatusChange: true
    }),
    _c = _b.data,
    data = _c === void 0 ? defaultData : _c,
    error = _b.error,
    loading = _b.loading;
  var t = (0, use_lang_1.useLang)();
  var fields = React.useMemo(function () {
    return (0, lodash_1.filter)(filters.createFields({
      t: t,
      data: data,
      loading: loading,
      definition: definition,
      entities: entities,
      icons: icons,
      entityTypeName: entityTypeName,
      theme: theme,
      options: options,
      currentUserCan: current_user_can_1.currentUserCan,
      values: values,
      client: client
    }), function (filterField) {
      return filterField && (!fieldNames.length || (0, lodash_1.includes)(fieldNames, filterField.name));
    });
  }, [data, values]);
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Filters, {
    name: "".concat(entityTypeName, "-filters"),
    labelRenderer: entity_filter_label_1.EntityFilterLabel,
    onChange: onChange,
    fields: fields
  }));
};
exports.EntityFilters = EntityFilters;
exports.EntityFilters.defaultProps = exports.EntityFiltersDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;